// eslint-disable-next-line @nx/enforce-module-boundaries
import { runOnFeatureInit } from '@frontend/vanilla/core';

import { LocationInfoStatusService } from './gds-fetch-location.service';
import { GeoCoordinatorBootstrapService } from './geo-coordinator-bootstrap.service';
import { GeoCoordinatorService } from './geo-coordinator.service';

export function provide() {
    return [GeoCoordinatorService, LocationInfoStatusService, runOnFeatureInit(GeoCoordinatorBootstrapService)];
}
